import React from "react";
import { Link } from "react-router-dom";
import { AiOutlineRollback } from "react-icons/ai";
import "../../pages/view.css";

const ViewGroupDiscount = () => {
  return (
    <div class="container">
      <div className="m-2 md:m-10 mt-24 p-2 md:p-10 bg-white rounded-3xl">
        <div class="flex justify-end active">
          <div class="backIcon">
            <Link to="/grouppromotionaldiscount">
              <AiOutlineRollback />
            </Link>
          </div>
        </div>
        <div class="flex justify-center text-left">
          <ul class="bg-white rounded-lg w-96 text-gray-900">
            <li class="px-6 py-2 border-b border-gray-200 w-full rounded-t-lg">
              Merchant : Shree
            </li>
            <li class="px-6 py-2 border-b border-gray-200 w-full">
              Percentage Discount : 10%
            </li>
            <li class="px-6 py-2 border-b border-gray-200 w-full">
              Valid From : 2022-05-05 18:20:00
            </li>
            <li class="px-6 py-2 w-full rounded-b-lg">
              Valid To : 2022-05-05 18:20:00
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ViewGroupDiscount;
